module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/consultation-6ec60138937cd8680121bcf8d9be149e.jpg";